import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-check-out-cart-detail-card',
  templateUrl: './mcommerce-virtual-cash-register-check-out-cart-detail-card.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-check-out-cart-detail-card.component.scss']
})
export class McommerceVirtualCashRegisterCheckOutCartDetailCardComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() { }

}
